export const DASHBOARDS_ITEM_KEY = '/';

export const DASHBOARDS_ITEM_KEY_PREFIX = '/dashboard/';

export const APPLICATIONS_ITEM_KEY_PREFIX = '/applications/';

export const APPLICATIONS_ITEM_KEY = '/applications';

export const PUBLISHED_MANIFESTS_KEY = '/published-manifests';

export const JOBS_ITEM_KEY = '/jobs';

export const JOBS_ITEM_KEY_PREFIX = '/jobs/';

export const RESOURCES_ITEM_KEY = '/resources';

export const INSTANCES_ITEM_KEY = '/instances';

export const INSTANCE_ITEM_KEY_PREFIX = '/instances/';

export const THEME_ITEM_KEY = 'theme';

export const NOTIFICATIONS_ITEM_KEY = '/notifications';

export const RELEASE_HISTORY_KEY = 'release-history';

export const BELLPORT_MESSAGE_MAPPING_KEY = 'normalization-guide';

export const DOCUMENTATION_CHAT = 'chat';

export const FILE_EXPLORER_KEY = '/file-explorer';

export const FILE_EXPLORER_KEY_PREFIX = '/file-explorer/';

export const DOCUMENTATION_KEY = '/documentation';

export const DOCUMENTATION_KEY_PREFIX = '/documentation/';

export const DATA_QUERY_KEY = '/data';

export const WORKFLOWS_KEY = '/workflow';

export const MY_DATA_ACTIVITY_KEY = '/my-data';

export const EXT_APPS_KEY = 'ext-apps';

export const MONITORING_APPS_KEY = '/monitoring';

export const MONITORING_APPS_KEY_PREFIX = '/monitoring/';

export const FEEDS_MONITOR_KEY = 'feeds-monitor';

export const STATUS_DASHBOARD_KEY = 'status-dashboard';

export const DATA_LAKE_MONITOR_KEY = 'data-lake-monitor';

export const APP_MONITOR_KEY = 'app-monitor';

export const SLA_MONITOR_KEY = 'sla-monitor';

export const RAW_FEED_DATA_KEY = '/raw-feed-data';

export const GLOBAL_SEARCH_KEY = '/global-search';

export const SPRINGBOARD_BROWSER_KEY = '/springboard-browser';

export const SUPERSET_VISUALISATIONS_KEY = '/visualisations-app';

export const searchableMenuItemLabelMap: { [key: string]: string } = {
  INSTANCES: `Instances`, //note that this will be used including the instance name
  RESOURCES: 'Resources',
  DASHBOARDS: 'Dashboards',
  JOBS: 'Jobs',
  APPLICATIONS: 'Applications',
  FX: 'File Browser',
  DOCUMENTATION: 'Documentation',
};

export const subPathMatches = {
  [DASHBOARDS_ITEM_KEY]: DASHBOARDS_ITEM_KEY_PREFIX,
  [APPLICATIONS_ITEM_KEY]: APPLICATIONS_ITEM_KEY_PREFIX,
  [JOBS_ITEM_KEY]: JOBS_ITEM_KEY_PREFIX,
  [FILE_EXPLORER_KEY]: FILE_EXPLORER_KEY_PREFIX,
  [INSTANCES_ITEM_KEY]: INSTANCE_ITEM_KEY_PREFIX,
  [MONITORING_APPS_KEY]: MONITORING_APPS_KEY_PREFIX,
};
